const GET_BREEDS = "GET_BREEDS";
const GET_BREEDS_FAVORITES = "GET_BREEDS_FAVORITES";
const POST_BREEDS_FAVORITES = "POST_BREEDS_FAVORITES";  
const DELETE_BREEDS_FAVORITES = "DELETE_BREEDS_FAVORITES";
const GET_DETAIL_BREED = "GET_DETAIL_BREED";
const GET_BREEDS_FILTER = "GET_BREEDS_FILTER";
const GET_TEMPERAMENTS = "GET_TEMPERAMENTS";
const FILTER_CREATED = "FILTER_CREATED" ; 
const FILTER_EXISTING =  "FILTER_EXISTING";
const FILTER_BY_TEMPERAMENT = "FILTER_BY_TEMPERAMENT";
const FILTER_BY_AZ = "FILTER_BY_AZ";
const FILTER_WEIGHT = "FILTER_WEIGHT";
const DELETE_USER = "DELETE_USER";
const LOGIN_USER = "LOGIN_USER";
const LOG_OUT = "LOG_OUT";

////////////////

const API_URL = "https://dogs-pi-api.up.railway.app";
const URL_GET_DOGS = `${API_URL}/dogs`;
const URL_GET_DOGS_BY_NAME = `${API_URL}/dogs?name=`;
const URL_POST_DOGS = `${API_URL}/dog`;
const URL_GET_TEMPERAMENTS  = `${API_URL}/temperament`;
const URL_POST_USER_REGISTER = 'user/register';
const URL_POST_USER_LOGIN = 'user/logIn';
const URL_DELETE_USER = 'user/delete';
const URL_FAVORITES = "/favorites";
const URL_FAVORITES_DELETE = '/favorites/delete';

module.exports = {
    GET_BREEDS,
    GET_BREEDS_FILTER,
    GET_BREEDS_FAVORITES,
    POST_BREEDS_FAVORITES,   
    DELETE_BREEDS_FAVORITES,
    GET_DETAIL_BREED,
    GET_TEMPERAMENTS,
    FILTER_CREATED,
    FILTER_EXISTING,
    FILTER_BY_TEMPERAMENT,
    FILTER_BY_AZ,
    FILTER_WEIGHT,
    DELETE_USER,
    LOGIN_USER,
    LOG_OUT,
    URL_GET_DOGS,
    URL_GET_DOGS_BY_NAME,
    URL_POST_DOGS,
    URL_GET_TEMPERAMENTS,
    API_URL,
    URL_POST_USER_REGISTER,
    URL_POST_USER_LOGIN,
    URL_DELETE_USER,
    URL_FAVORITES,
    URL_FAVORITES_DELETE,
    
}
